import type { IconSvgObject } from './types';

const PlusMinusCircle01Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 16.5H8.5M9 10.5H12M12 10.5H15M12 10.5V7.5M12 10.5V13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PlusMinusCircle01Icon;
